var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LvStateDropdownRadioInputAvatar001',{attrs:{"outline":"","avatar-select":"","required":"","title":"覆核人員","leading-icon":"icon-outline-perm-identity","rules":"required","placeholder":"覆核人員覆核人員"},model:{value:(_vm.state),callback:function ($$v) {_vm.state=$$v},expression:"state"}})
}
var staticRenderFns = []

export { render, staticRenderFns }